import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBB1j9-JXCWr28vAcKxsRMfdi7_WGCRxSc',
  authDomain: 'vossingers-afterwork.firebaseapp.com',
  databaseURL: 'https://vossingers-afterwork-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'vossingers-afterwork',
  storageBucket: 'vossingers-afterwork.appspot.com',
  messagingSenderId: '572874409216',
  appId: '1:572874409216:web:9be56e7979609f3efe1fe5',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);

export default app;
